import ExteriorScreenInfo from './ExteriorScreenInfo'

export default ExteriorScreenInfo
